import { render, staticRenderFns } from "./PatientContactsList.vue?vue&type=template&id=59054c74&"
import script from "./PatientContactsList.vue?vue&type=script&lang=js&"
export * from "./PatientContactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports